import { taggedTemplateLiteral as _taggedTemplateLiteral, slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState } from 'react';
import styled from 'styled-components';
import { SearchIcon, EmailIcon, ShopIcon } from '../Icons/index.js';
import { Montserrat } from '../../assets/fonts.js';
import { gold } from '../../assets/colors.js';
import getPgaTld from '../../getPgaTld.js';
import HeaderMailModal from '../HeaderMailModal/index.js';
import handleMailClick from '../HeaderMailModal/handleMailClick.js';

var _templateObject, _templateObject2, _templateObject3;
var IconsBox = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  padding-right: 20px;\n  flex-grow: 0;\n  align-content: center;\n  margin-left: auto;\n  width: 50%;\n"])));
var StyledText = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-weight: 500;\n  font-family: ", ";\n  color: ", ";\n  align-self: center;\n  margin: 0;\n  font-size: 12px;\n  line-height: 0.8;\n  white-space: nowrap;\n  display: flex;\n  align-content: center;\n"])), Montserrat, gold);
var ExternalLinkWrapper = styled.a.attrs(function (_ref) {
  var target = _ref.target;
  return {
    target: target,
    rel: target === "_blank" ? "noopener noreferrer" : ""
  };
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-decoration: none;\n  &:hover {\n    text-decoration: none;\n    opacity: 0.8;\n  }\n  @media (max-width: 1199px) {\n    ", " {\n      display: none;\n    }\n  }\n"])), StyledText);
var pgaTld = getPgaTld();
var index = (function (_ref2) {
  var isLoggedIn = _ref2.isLoggedIn,
    _ref2$meEmailMigratio = _ref2.meEmailMigrationData,
    meEmailMigrationData = _ref2$meEmailMigratio === void 0 ? {} : _ref2$meEmailMigratio,
    onToggleDoNotShowAgain = _ref2.onToggleDoNotShowAgain,
    me = _ref2.me;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    modalType = _useState4[0],
    setModalType = _useState4[1];
  return /*#__PURE__*/React__default.createElement(IconsBox, null, /*#__PURE__*/React__default.createElement(HeaderMailModal, {
    open: open,
    onToggle: setOpen,
    type: modalType,
    meEmailMigrationData: meEmailMigrationData,
    onToggleDoNotShowAgain: onToggleDoNotShowAgain,
    me: me
  }), /*#__PURE__*/React__default.createElement(ExternalLinkWrapper, {
    href: "https://resources.".concat(pgaTld)
  }, /*#__PURE__*/React__default.createElement(SearchIcon, {
    className: "d-flex"
  })), !isLoggedIn ? /*#__PURE__*/React__default.createElement(ExternalLinkWrapper, {
    href: "https://account.".concat(pgaTld, "/login?return_to=https://account.").concat(pgaTld, "/mail-redirect")
  }, /*#__PURE__*/React__default.createElement(EmailIcon, {
    pr: 5,
    className: "d-flex"
  })) : /*#__PURE__*/React__default.createElement("div", {
    onClick: function onClick() {
      return handleMailClick({
        meEmailMigrationData: meEmailMigrationData,
        setModalType: setModalType,
        setOpen: setOpen
      });
    }
  }, /*#__PURE__*/React__default.createElement(EmailIcon, {
    pr: 5,
    className: "d-flex"
  })), /*#__PURE__*/React__default.createElement(ExternalLinkWrapper, {
    target: "_blank",
    href: "https://shopmyshop.com/?application=a496c986-a442-46b0-bdaf-4cfca0a61c93"
  }, /*#__PURE__*/React__default.createElement(ShopIcon, {
    pr: 5,
    className: "d-flex"
  })));
});

export { ExternalLinkWrapper, IconsBox, StyledText, index as default };
